import { FluxStandardAction, IFlashShower } from "__utils/type";
import * as Actions from "constants/actions";

export const showFlashDiv = (flashAttr: IFlashShower): FluxStandardAction => {
    return {
        type: Actions.SHOW_FLASH_MESSAGE,
        payload: flashAttr
    }
};

export const hideFlashDiv = (): FluxStandardAction => {
    return {
        type: Actions.HIDE_FLASH_MESSAGE,
    }
};